import React from 'react';
import ToolTip from './ToolTip';

interface InfoTooltipProps {
  text: string;
  position?: 'top' | 'right' | 'bottom' | 'left';
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  text,
  position = 'top',
}) => {
  return (
    <ToolTip text={text} position={position}>
      <span className="text-[#172B4D] cursor-pointer">ⓘ</span>
    </ToolTip>
  );
};

export default InfoTooltip;
